import type { ChangeSet } from './types.js';

/**
 * Change history (U50, OIL-24): one entry per stored edit window – who, when, what. `what` is a
 * compact list of the changed entities taken from the catch-up change set (plot only: rows are
 * the same entities seen through the tables).
 */

/** At most this many changes per entry; the rest is counted in `more`. */
export const HISTORY_MAX_CHANGES = 100;

export interface HistoryChange {
  collection: string;
  id: string;
  kind: 'added' | 'removed' | 'changed';
  label: string;
  fields: string[];
}

export function historyChanges(cs: ChangeSet): { changes: HistoryChange[]; more: number } {
  const all = cs.plot.map((c) => ({
    collection: c.collection,
    id: c.id,
    kind: c.kind,
    label: c.label,
    fields: c.fields,
  }));
  return {
    changes: all.slice(0, HISTORY_MAX_CHANGES),
    more: Math.max(0, all.length - HISTORY_MAX_CHANGES),
  };
}
